export default "__VITE_ASSET__BEim0$9L__"